export default class ValidationErrors {
  constructor(errors = []) {
    this._errors = errors;
    this._bindErrorsToThis();
  }

  get valid() {
    return this._errors.length == 0;
  }
  get invalid() {
    return this._errors.length > 0;
  }
  get length() {
    return this._errors.length;
  }
  get map() {
    return this._errors.map;
  }
  get forEach() {
    return this._errors.forEach;
  }
  get filter() {
    return this._errors.filter;
  }

  // Usage examples:
  // - hasValidProp()
  // - hasValidProp("product")
  // - hasValidProp("product.product_variants")
  // - hasValidProp("product.product_variants[123]")
  // - hasValidProp("product.product_variants[123].translations[3]")
  // - hasValidProp("product.product_variants[123].translations[3].name")
  hasValidProp(prop = "") {
    return (
      this._errors.filter(([key, _]) => {
        return key === prop || key.indexOf(`${prop}[`) === 0 || key.indexOf(`${prop}.`) === 0;
      }).length === 0
    );
  }

  clear() {
    Object.keys(this).forEach((key) => {
      delete this[key];
    });
    this._errors = [];
  }

  add(key, error) {
    if (error === undefined) {
      return;
    }
    this._errors.push([key, error]);
    this._bindErrorsToThis();
  }

  toArray() {
    return this._errors;
  }

  toObject() {
    return this._errors.reduce((obj, [key, error]) => {
      return {
        ...obj,
        [key]: obj[key] ? [obj[key], error].join("; ") : error,
      };
    }, {});
  }

  _bindErrorsToThis() {
    Object.assign(this, this.toObject());
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/form/ValidationErrors.js